<template>
    <div>
        <b-table-simple responsive>
            <b-thead>
                <b-tr>
                    <b-th>{{$t('fmweb.regel')}}</b-th>
                    <b-th>{{$t('fmweb.grootboek')}}</b-th>
                    <b-th>{{$t('fmweb.grootboeknaam')}}</b-th>
                    <b-th>{{$t('fmweb.relatie')}}</b-th>
                    <b-th>{{$t('fmweb.debet')}}</b-th>
                    <b-th>{{$t('fmweb.credit')}}</b-th>
                    <b-th>{{$t('fmweb.omschrijving')}}</b-th>
                </b-tr>
            </b-thead>
            <b-tbody>
                <b-tr v-for="item in invoice.booking.lines" :key="item.ruleNr">
                    <b-td>{{ item.lineNumber }}</b-td>
                    <b-td>{{ item.ledger.number }}</b-td>
                    <b-td>{{ item.ledger.name }}</b-td>
                    <b-td>{{ item.costcenter }}</b-td>
                    <b-td>{{ item.debit }}</b-td>
                    <b-td>{{ item.credit }}</b-td>
                    <b-td>{{ item.description }}</b-td>
                </b-tr>
            </b-tbody>
        </b-table-simple>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";

    export default {
        name: "FactuurBoekingsregelsTabel",
        props: {
          selectedInvoiceId: null
        },
        computed: {
            ...mapGetters('fmwebapp',['invoice']),
        },
        methods: {
            ...mapActions('fmwebapp', ['all', 'find']),
        },
        created() {
            var vm = this;
            vm.find({
                resource: 'invoices',
                id: this.selectedInvoiceId
            })
        }
    }
</script>